<template>
  <v-container class="container--max">
    <slot name="ad-leaderboard" v-if="! hasHeroSlot"></slot>
    <slot name="hero" v-if="hasHeroSlot"></slot>
    <v-row justify="center" class="my-4">
      <!-- left -->
      <v-col cols="12" sm="11" md="7" lg="8">
        <slot name="main"></slot>
      </v-col>
      <!-- right -->
      <v-col cols="12" md="4" lg="3" offset-lg="1">
        <slot name="sidebar"></slot>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'AppIndex',

    computed: {
      hasHeroSlot() {
        return !! this.$slots.hero
      }
    }
  }
</script>